// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1YhG0","col":"Table_col__2TYHL","fulfillmentStatus":"Table_fulfillmentStatus__2PGl8","emailCol":"Table_emailCol__2lnRg"};